import { render, staticRenderFns } from "./Assertion.vue?vue&type=template&id=9b6f9e24"
import script from "./Assertion.vue?vue&type=script&lang=js"
export * from "./Assertion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports